import React, {useState} from "react";
import {getDataFresh, getRentalMarginData} from "../../../state/selectors";
import {useDispatch, useSelector} from "react-redux";
import { Box, Table, Title } from "@allxsmith/bestax-bulma";
import NewRentalMargin from "./NewRentalMargin";
import RentalMarginRow from "./RentalMarginRow";
import Spinner from "react-spinner-material";
import {createSetRentalMarginDataAction} from "../../../actions/dataActions";
import {useRentalMarginData} from "../../../hooks/useRentalMarginData";


export default function RentalMargin(props){
    const [page, setPage] = useState(1)
    const dispatch = useDispatch();
    const datafresh = useSelector(getDataFresh)
    let params = {page: page}
    let complete = useRentalMarginData(params, datafresh)
    const data = useSelector(getRentalMarginData)

    const onRentalMarginUpdate = (index, newRentalMargin) => {
        let newResults = [...data.results]
        let newState = {...data, results: newResults};
        newState.results[index] = newRentalMargin;
        dispatch(createSetRentalMarginDataAction(newState))
    }

    if (!complete) {
      return (
        <Box>
          <Spinner
            className="spinner-centre"
            size={120}
            spinnerColor={"#3273dc"}
            spinnerWidth={2}
          />
        </Box>
      );
    }

    return (
        <div>
            <NewRentalMargin />
            <Box>
                <details>
                    <summary><Title>Rental Margin</Title></summary>
                    <Title size="6">Note: Changing these will affect all vehicles of that make</Title>
                    <Table
                        isFullwidth
                    >
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Margin (%)</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                            {data.results.map((margin, index) => (
                              <RentalMarginRow
                                marginData={margin}
                                index={index}
                                onUpdate={onRentalMarginUpdate}
                                dataFresh={datafresh}
                              />
                            ))}
                        </tbody>
                    </Table>
                </details>
            </Box>
        </div>
    );






}